import { HeaderMode, SiteHeaderService } from 'src/app/site-header/site-header.service';
import {
    Component,
    OnInit,
    Input,
    ElementRef,
    ViewChild,
    AfterViewInit,
    ViewContainerRef,
    OnDestroy,
    ChangeDetectorRef,
    inject,
} from '@angular/core';
import { AppGlobalsModule } from '../app-globals.module';
import { SiteHeaderComponent } from '../site-header/site-header.component';
import { SiteFooterComponent } from '../site-footer/site-footer.component';
import { UrlAddressService } from '../core/services/url-address/url-address.service';
import { SiteModeService } from '../core/services/site-mode/site-mode.service';
import { Subscription } from 'rxjs';

const classesMap = {
    header: SiteHeaderComponent,
    footer: SiteFooterComponent,
};

@Component({
    selector: 'esi-factory-ng',
    templateUrl: './esi-factory.component.html',
    styleUrls: ['./esi-factory.component.scss'],
    standalone: false,
})
export class EsiFactoryComponent implements OnInit, AfterViewInit, OnDestroy {
    private elementRef = inject(ElementRef);
    urlAddress = inject(UrlAddressService);
    private _siteHeaderService = inject(SiteHeaderService);
    private _siteModeService = inject(SiteModeService);
    private _changeDetectorRef = inject(ChangeDetectorRef);
    private _forceError = inject<boolean>('forceError' as any, { optional: true })!;

    @ViewChild('esiHost', { read: ViewContainerRef }) EsiHost!: ViewContainerRef;
    @Input() contents!: string;

    get isServer(): boolean {
        return AppGlobalsModule.isServer;
    }
    get isDevelopment(): boolean {
        return AppGlobalsModule.isDevelopment;
    }

    public _isEsiMode!: boolean;
    private _view!: keyof typeof classesMap;
    private minimalSub: Subscription | undefined;
    public isMinimal = false;

    ngOnInit() {
        // Throw erroe after 10 seconds
        if (this._forceError) {
            setTimeout(() => {
                throw Error(`force error for testing`);
            }, 15000);
        }

        this.addEsiElement();

        // Set the minimal mode for header
        this.minimalSub = this._siteModeService.getMinimalMode$().subscribe({
            next: (minimalMode) => {
                this.isMinimal = minimalMode;
                this._changeDetectorRef.detectChanges();
            },
        });
    }

    ngAfterViewInit(): void {
        this.loadDynamicComoonent();
    }

    ngOnDestroy() {
        if (this.minimalSub) {
            this.minimalSub.unsubscribe();
        }
    }

    private loadDynamicComoonent() {
        if (!classesMap[this._view]) {
            throw Error(`Can't find component name ${this._view}`);
        }

        // Since AppServerModule load all the esi factory and all the children modules wrappers (header and footer), it would init twice.
        if (this.EsiHost) {
            const componentRef = this.EsiHost.createComponent(classesMap[this._view].prototype.constructor as any);
            if (classesMap[this._view] === classesMap.header && this.urlAddress.getParam('mode')) {
                let mode = this.urlAddress.getParam('mode')!.toString().toLowerCase();
                if (mode === 'inner-mode') {
                    mode = HeaderMode.Static; //the value before 2026-10-13, still in cached pages' esi includes - drop once they expired
                }
                (componentRef.instance as SiteHeaderComponent).headerMode.set(mode as HeaderMode);
            }
        }
    }

    private addEsiElement() {
        // We take attibite and not input due to root level of application (on universal) can't pick up Inputs
        this._view = this.elementRef.nativeElement.getAttribute('view').toLowerCase();

        // In Universal to general page it woun't get the reference from server.ts
        let esiMode = this.urlAddress.getParam('esimode') ?? this.urlAddress.getParam('esiMode');

        this._isEsiMode =
            // Client is never ESI
            this.isServer &&
            // Default is all the pages to use ESI template exept the template path itself unless forced with 'varnish' parameter.
            (esiMode === 'varnish' || !this.urlAddress.getURL().startsWith('/esi_angular')) &&
            // enable option to give the full template
            esiMode !== 'direct';

        // &&
        // // In debug always return full tamplate
        // environment.production;

        // If we're in the path of ESI we shouldn't include ESI again recursively
        if (this.isServer && this._isEsiMode) {
            const htmlElement = this.elementRef.nativeElement as HTMLElement;

            // Add ESI for varnish to create the menu while server gives response,
            // And Esi-Factory to avoid recursive call and enable open module on angular elements for client.
            let mode =
                classesMap[this._view] !== classesMap.header
                    ? 'none'
                    : this._siteHeaderService.getHeaderMode();

            htmlElement.outerHTML = `<!--esi <esi:include src="/esi_angular?view=${this._view}&esimode=direct&mode=${mode}" /> -->`;
        }
    }
}
